import React from "react";
import Flagship from "../../core/flagship";
import { getFormattedValue } from "../../utils/helpers";
import { Link } from "react-router";
import { Icon } from "semantic-ui-react";

export default class FileUploadFieldView extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.getFiles = this.getFiles.bind(this);

    this.s3Url = "https://" + Flagship.config.awsBucket + ".s3.amazonaws.com";
    this.state = {
      files: [],
      loading: true,
      uploading: false,
      progress: 0
    };
  }

  componentDidMount() {
    this.getFiles();
  }

  getFiles() {
    let self = this;
    Flagship.get(
      "s3/list",
      {
        bucket: Flagship.config.awsBucket,
        folder: self.props.folder
      },
      function(response) {
        if (response.data.success === true && response.data.files !== null) {
          self.setState({
            files: response.data.files,
            loading: false
          });
        } else if (response.data.files === null) {
          self.setState({
            files: [],
            loading: false
          });
        } else {
          self.setState({
            files: [],
            loading: false
          });
          Flagship.error(
            "Failed to list files.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function(err) {
        self.setState({
          loading: false
        });
        Flagship.error(
          "Failed to list files: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  onViewDownloadFile(file) {
    window.open(Flagship.config.apiBase + "file?path=" + file);
  }

  render() {
    return (
      <div>
        {this.state.files.length
          ? this.state.files.map(function(file, i) {
              return (
                <div className="file-in-list" key={"file" + i}>
                  <Link
                    target="_blank"
                    to={
                      Flagship.config.apiBase +
                      "file?path=" +
                      encodeURIComponent(file.Key)
                    }
                  >
                    <Icon name="cloud download" />
                    {file.Key.replace(/^.*[\\\/]/, "")}
                  </Link>
                  <small className="float-right">
                    {getFormattedValue(file.Size, "filesize")}
                  </small>
                </div>
              );
            })
          : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/misc/FileUploadFieldView.js